import React from 'react';
import Spinner from './spinner';

export default () => <Spinner />;
